export const widgets = {
  zohoCrm: {
    settings: {
      welcomeToBotPenguin: 'Dobrodošli na BotPenguin!',
      login: 'Prijava',
      youAreAllSet: 'Sve je postavljeno! Možete koristiti WhatsApp inbox s detaljima o potencijalnim kupcima.',
      placeholders: {
        enterEmail: 'Unesite email',
        enterPassword: 'Unesite lozinku'
      }
    }
  }
};

